import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LoaderModule } from '@x/common/loader/loader.module';
import { BottomSheetLayoutComponent } from '@x/ecommerce-shop/app/core/shop-ui/components/layout/bottom-sheet-layout/bottom-sheet-layout.component';

@NgModule({
  declarations: [BottomSheetLayoutComponent],
  imports: [CommonModule, LoaderModule],
  exports: [BottomSheetLayoutComponent],
})
export class BottomSheetLayoutModule {}
